type StudyQueryListParams = {
  study_id: string
  subjectId?: string | null
  qcTaskId?: string | null
  search?: string | null
  limit?: number | null
  nextCursor?: string | null
  previousCursor?: string | null
  orderByField?: string | null
  ascOrder?: boolean | null
}

const studyQueryKeys = {
  all: (studyId: string) => ['studyQueries', studyId] as const,
  lists: () => [...studyQueryKeys.all(''), 'list'] as const,
  list: (params: StudyQueryListParams) => [...studyQueryKeys.all(params.study_id), 'list', params] as const,
  details: (studyId: string) => [...studyQueryKeys.all(studyId), 'detail'] as const,
  detail: (studyId: string, queryId: string) => [...studyQueryKeys.details(studyId), queryId] as const,
  metadata: (studyId: string, qcTaskId: string, siteId: string, subjectId: string, timepointSubmissionId: string) =>
    [...studyQueryKeys.all(studyId), 'metadata', qcTaskId, siteId, subjectId, timepointSubmissionId] as const,
}

export default studyQueryKeys
